/* eslint-disable camelcase */
<template>
  <div v-role="'func'">
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1000px">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-card-title style="background-color: #006699; color: white"
            >Definição Valor de Multa
          </v-card-title>
          <!-- <v-btn  to="pesquisar-valor-multas" style="background-color:#fff;color:#006699;float:right;margin-top:-45px;" outlined> <v-icon md color="#006699 darken-2">list</v-icon> Consultar Valores definidos </v-btn > -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-container>
                <div
                  v-if="$store.state.hasMessage"
                  :class="$store.state.classMessage"
                >
                  {{ $store.state.textMessage }}
                </div>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-combobox
                      outlined
                      v-model="cursoSelected"
                      :rules="ruleRequired"
                      item-value="idCurso"
                      item-text="descricao"
                      :items="cursos"
                      @change="initializeClasses()"
                      chips
                      label="Selecione o Curso"
                    ></v-combobox>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      outlined
                      v-model="classeSelected"
                      :rules="ruleRequired"
                      item-value="idAno_Academico"
                      item-text="descricao"
                      :items="classesFiltered"
                      chips
                      :label="
                        nivelEnsino === 1
                          ? 'Selecione o ano'
                          : 'Selecione a classe'
                      "
                      return-object
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6" v-if="false">
                    <v-switch
                      :disabled="true"
                      v-model="opcao1"
                      label="Aplicar as definições em todos os anos independemente do curso"
                    ></v-switch>
                  </v-col>

                  <v-col cols="12" md="6" v-if="false">
                    <v-switch
                      :disabled="true"
                      v-model="opcao2"
                      :label="` ${
                        cursoSelected === null
                          ? ''
                          : 'Aplicar as definições somente nos anos de ' +
                            cursoSelected.descricao
                      }`"
                    ></v-switch>
                  </v-col>

                  <v-col
                    cols="12"
                    md="12"
                    v-if="opcao1 === false && opcao2 === false && false"
                  >
                    <span style="font-weight: bold">Nota:</span
                    ><span>
                      Ao não selecionar nenhuma das opções acima , as definições
                      serão gravadas apenas para a ano selecionada do curso de
                      {{
                        cursoSelected !== null ? cursoSelected.descricao : ""
                      }}.</span
                    >
                  </v-col>

                  <v-col cols="12" md="12" v-if="false">
                    <v-select
                      outlined
                      :disabled="true"
                      v-model="tipoMultaSelected"
                      :rules="ruleRequired"
                      item-value="id"
                      item-text="descricao"
                      :items="tipoMulta"
                      chips
                      label="Tipo de Multa"
                      return-object
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-if="!showFixos"
                      :rules="ruleNumber"
                      v-model="percentual1"
                      :disabled="tipoMultaSelected === null"
                      label="Valor para multa"
                    ></v-text-field>

                    <v-text-field
                      outlined
                      :disabled="!cursoSelected || !classeSelected"
                      v-if="showFixos"
                      v-money="money"
                      v-model="fixo1"
                      label="Valor para multa"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid && novo" color="success" @click="save()"
                ><v-icon>send</v-icon>Guardar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from "../../plugins/axios";
import { mask } from "vue-the-mask";
import { VMoney } from "v-money";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    money: {
      decimal: ",",
      thousands: ".",
      suffix: " Kz",
      precision: 2,
      masked: false,
    },
    progresso: false,
    overlay: false,
    novo: false,
    valid: true,
    ano_actual: ls.get("anolectivo"),
    habilitaBi: false,
    startDate: null,
    classeSelected: null,
    showFixos: true,
    opcao1: false,
    opcao2: false,
    cursos: [],
    classes: [],
    classesFiltered: [],
    tipoMultaSelected: { id: 2, descricao: "Fixo" },
    menuMulta1: false,
    dateMulta1: false,
    dataMulta1Selected: null,
    menuMulta2: false,
    dateMulta2: false,
    dataMulta2Selected: null,
    menuMulta3: false,
    dateMulta3: false,
    dataMulta3Selected: null,
    percentual1: 0,
    percentual2: 0,
    fixo1: 0,
    fixo2: 0,
    isLoading: false,
    servico: "",
    cor: "",
    maxYear: "2025-12-31",
    minYear: "1950-01-01",
    searchInDb: "",
    mesSelected: null,
    cursoSelected: null,
    preco: 0,
    servicos: [],
    multasExistentes: [],
    servicosTabela: [],
    valorFormatado: "",
    dialog: false,
    idd: false, // simula autoinclemet

    y: "top",
    text: "mensagem nao setada.",

    //  timeout: 4000,
    tipoMulta: [
      // { id: 1, descricao: 'Percentual' },
      { id: 2, descricao: "Fixo" },
    ],
    ruleNumber: [
      (value) => !!value || "campo obrigatório.",
      (value) => {
        const pattern = /^[0-9]*$/;
        return pattern.test(value) || "Invalido.";
      },
    ],
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 50 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],

    msg: "",
    editedIndex: -1,
  }),

  computed: {
    loggedUserName() {
      return ls.get("nomeUsuario");
    },

    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },

    ListaActividades() {
      return ls.get("lista_actividades");
    },

    nivelEnsino() {
      return ls.get("nivel");
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menuMulta1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menuMulta2(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menuMulta3(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dialog(val) {
      val || this.close();
    },
    opcao1(val) {
      if (val === true) {
        this.opcao2 = false;
      }
    },
    opcao2(val) {
      if (val === true) {
        this.opcao1 = false;
      }
    },
  },

  created() {
    this.initializeCursos();
    // this.initializeMultas()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log("elso foraaa");
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios
          .get("/cursoInstituicaoFindAllIntegracao")
          .then((res) => res.data);
        // this.cursos.unshift({ descricao: "Todos cursos", idCurso: -1 });
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    SelectMulta() {
      if (this.tipoMultaSelected.id === 1) {
        this.showFixos = false;
      } else if (this.tipoMultaSelected.id === 2) {
        this.showFixos = true;
      }
      this.Limpar();
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (
          let index = 1;
          index <= parseInt(this.cursoSelected.numero_anos_academicos);
          index++
        ) {
          this.classesFiltered.push({ id: index, descricao: index + "º ano" });
        }
        this.classesFiltered.push({ id: 100, descricao: "Monografia" });
      } else {
        let classe = 10;
        // this.classesFiltered.unshift({ id: -1, descricao: "Todas classes" });
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({
            id: index,
            descricao: classe + "ª Classe",
          });
          classe++;
        }
      }
    },
    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classesFiltered = await axios
          .get("/anoacademicoFindAll")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    chamaDialogo() {
      this.dialog = true;
    },

    close() {
      this.$refs.form.reset();
    },
    ObterValorFormatado(valor) {
      let formated = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "AOA",
      }).format(valor);
      this.valorFormatado = formated.toString().replace("AOA", "");
    },
    Limpar() {
      this.fixo1 = 0;
      this.fixo2 = 0;
      this.percentual1 = 0;
      this.percentual2 = 0;
    },

    async save() {
      if (this.$refs.form.validate()) {
        if (typeof this.cursoSelected === "object") {
          this.overlay = true;
          let params = {
            id: 0,
            tipoMulta: this.tipoMultaSelected.descricao,
            fk_classe: this.classeSelected.idAno_Academico,
            classe: this.classeSelected.descricao,
            pk_curso: this.cursoSelected.idCurso,
            cursoDescricao: this.cursoSelected.descricao,
            percentual1: this.percentual1,

            valor1: utilitarios.MoneyValueToInteger(this.fixo1),

            aplicarClassesSemCurso: this.opcao1,
            aplicarClassesComurso: this.opcao2,
            autor: ls.get("idPessoa"),
          };
          try {
            let result = await axios
              .post("/definirValorInsertOrUpdate", params)
              .then((res) => res.data);

            if (result.affectedRows >= 1) {
              this.Clean();
              utilitarios.showAlertMessage(
                "success",
                "Valor da multa definido com sucesso."
              );
            } else {
              utilitarios.showAlertMessage(
                "error",
                "Erro ao tentar efectuar a operação"
              );
            }
          } catch (error) {
            if (error.toString().includes("409")) {
              utilitarios.showAlertMessage(
                "warning",
                "Valor de multa já definido"
              );
            } else {
              utilitarios.showAlertMessage(
                "error",
                "Erro ao tentar efectuar a operação"
              );
            }
          } finally {
            this.overlay = false;
          }
        } else {
          utilitarios.showAlertMessage("warning", "Curso inválido");
        }
      }
    },
    Clean() {
      this.cursoSelected = "";
      this.tipoMultaSelected = "";
      this.classeSelected = "";
      this.percentual1 = "";
      this.percentual2 = "";

      this.fixo1 = "0";
      this.fixo2 = "0";

      this.opcao1 = false;
      this.opcao1 = false;

      this.resetValidation();
    },
    async initializeMultas() {
      try {
        //   let  payload =""

        this.isLoading = true;
        this.multasExistentes = await axios
          .get("/definirMultasExistente")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
<style scoped>
.bg {
  color: green;
  background: red;
}
</style>
